import { getSupabase, isSupabaseConfigured } from 'shared/supabase/client';
import { fetchWithFallback } from 'shared/data/fetchWithFallback';

export type EnrollmentNotice = {
  id: string;
  userId: string;
  institutionId: string;
  batchId: string;
  message: string;
  createdAt: string;
};

function mapRow(row: Record<string, unknown>): EnrollmentNotice {
  return {
    id: String(row.id),
    userId: String(row.user_id),
    institutionId: String(row.institution_id),
    batchId: String(row.batch_id),
    message: String(row.message ?? ''),
    createdAt: String(row.created_at ?? ''),
  };
}

async function listOpenFromSupabase(limit = 3): Promise<EnrollmentNotice[]> {
  const { data, error } = await getSupabase()
    .from('stud_enrollment_notices')
    .select('id, user_id, institution_id, batch_id, message, created_at')
    .is('dismissed_at', null)
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) throw new Error(error.message);
  return (data ?? []).map((row) => mapRow(row as Record<string, unknown>));
}

export async function listOpenEnrollmentNotices(limit = 3): Promise<EnrollmentNotice[]> {
  if (!isSupabaseConfigured) return [];
  return fetchWithFallback(
    () => listOpenFromSupabase(limit),
    async () => [],
  );
}

export async function dismissEnrollmentNotice(id: string): Promise<void> {
  if (!isSupabaseConfigured) return;
  const { error } = await getSupabase()
    .from('stud_enrollment_notices')
    .update({ dismissed_at: new Date().toISOString() })
    .eq('id', id);
  if (error) throw new Error(error.message);
}
